module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product21-5f7d71dbfe003bdc4bcd2f873edd85c4.jpg";